module.exports = __webpack_public_path__ + "/build/web/images/recently-posted@2x.f3e189e1428540ee0a816087ad493452.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/recently-posted@2x.jpg
// module id = 189
// module chunks = 13